module.exports = __webpack_public_path__ + "img/default-document.caf97c0b.jpg";